import React from 'react';
export const CFIconChevronsUp = {
    alias: 'chevrons-up',
    defaultTitle: 'Chevrons Up',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm11.989 7.292-5.362 4.315a1 1 0 0 1-1.254-1.56l6-4.827a.998.998 0 0 1 1.267.012l6 5A.998.998 0 0 1 18 12c-.226 0-.453-.077-.64-.232l-5.371-4.476Zm-.616 4.928a.998.998 0 0 1 1.267.011l6 5a1 1 0 0 1-1.28 1.536l-5.37-4.475-5.363 4.314a.999.999 0 1 1-1.254-1.558l6-4.828Z' }))),
};
